import axios from '@/utils/api'

const actions = {
  async getGuestTokenInterno ({ commit }) {
    return axios({
      url: `superset/interno/guest-token`,
      method: 'GET'
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/superset.js